export default __webpack_public_path__ + "static/media/fullscreen.23a5b587.svg";